import React, { useLayoutEffect, useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import useGetStoreById from 'sdk/hooks/shop/useGetStoreById';
import Page from 'modules/app/components/Page';
import s from './StoreProfile.module.scss';
import StoreProfileTop from './StoreProfileTop/StoreProfileTop';
import About from './About/About';
import { useActions } from 'store/useActions';
import Products from './Products/Products';
import GiftCards from './GiftCards/GiftCards'; 
import TopMenuForShopWithBack from 'modules/feed/components/Feed/TopMenuForShop/TopMenuForShopWithBack';
import ShoppingCart from '../../ShoppingCart';
import { useTypedSelector } from 'store/useTypedSelector';
import { useTranslation } from 'react-i18next';

const StoreProfile = () => {
    const { id } = useParams();
    const location = useLocation();
    const { data, refetch } = useGetStoreById(id || '');
    const { setIsSlideChange, setIsOpenBasket } = useActions();
    const { isOpenBasket } = useTypedSelector(state => state.postSlice);
    const navigate = useNavigate();
    const { t } = useTranslation() as any;

    const tabs = [
        { id: 1, title: 'About' },
        { id: 2, title: 'Products' },
        { id: 3, title: 'Gift Cards' },
    ];

    const [tab, setTab] = useState(location.state?.tab || tabs[0].id);

    useLayoutEffect(() => {
        setIsSlideChange(false);
        if (location.state?.restoreScroll && location.state?.scrollPosition) {
            window.scrollTo(0, location.state.scrollPosition);
        } else {
            window.scrollTo(0, 0);
        }
    }, [location.state]);

    useEffect(() => {
        let timeoutId: NodeJS.Timeout;

        if (location.state?.restoreScroll && typeof location.state?.scrollPosition === 'number') {
            timeoutId = setTimeout(() => {
                window.scrollTo({
                    top: location.state.scrollPosition,
                    behavior: 'auto',
                });
            }, 0);
        }

        return () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        };
    }, [location.state, tab]);

    const handleCloseMenu = () => {
        navigate(-1);
    };

    return (
        <div>
            <Page marginBottomNone activeLink="/shop">
                <div style={{ position: 'relative' }}>
                    {/* Transparent overlay menu */}
                    <div style={{ position: 'absolute', zIndex: 800, width: '100%' }}>
                        <TopMenuForShopWithBack
                            icon={'goBack'}
                            title={data?.store_name || ''}
                            openBasket={() => setIsOpenBasket(false)}
                        />
                    </div>
                    
                    <div className={s.container}>
                        <div className={s.containerInner}>
                        <StoreProfileTop
                            data={data}
                            refetch={refetch}
                            tab={tab}
                            setTab={setTab}
                            tabs={tabs}
                        />
                        {tab === 1 && data?.id && <About data={data} />}
                        {tab === 2 && <Products storeId={data?.id} />}
                        {tab === 3 && <GiftCards />}
                        </div>
                    </div>
                </div>
            </Page>
            <ShoppingCart open={isOpenBasket} setOpenShoppingCartMenu={setIsOpenBasket} />
        </div>
    );
};

export default StoreProfile;